export class ProblemDetails{
    private oldProbHeader:string = null;
    private oldDescription:string = null;
    private oldRootCause:string = null;
    private oldPropAction:string = null;
    constructor(private _probHeader:string,private _description:string,private _probId:string,
                private _startDate:number,private _endDate:number, private _rootCause:string,
                private _causes:Array<ProblemCause>,private _proposedAction:string,
                private _actions:Array<ProblemAction>,private _comments:Array<ProblemComment>,
                private _status:string,private _docTs:number){

    }
    get header():string{
        return this._probHeader;
    }
    set header(_head:string){
        if(this.oldProbHeader == null){
            this.oldProbHeader = this._probHeader;
        }
        this._probHeader = _head;
    }
    isHeaderChanged():boolean{
        if(this.oldProbHeader != null && this.oldProbHeader != this._probHeader) return true;
        return false;
    }
    get description():string{
        return this._description;
    }
    set description(_desc:string){
        if(this.oldDescription == null){
            this.oldDescription = this._description;
        }
        this._description = _desc;
    }
    isDescriptionChanged():boolean{
        if(this.oldDescription != null && this.oldDescription != this._description) return true;
        return false;
    }
    get id():string{
        return this._probId;
    }
    get startDateObj():Date{
        return new Date(this._startDate);
    }
    get startDate():number{
        return this._startDate;
    }
    get docTs():number{
        return this._docTs;
    }
    set startDate(_dt:number){
        this._startDate = _dt;
    }
    get endDate():number{
        return this._endDate;
    }
    get endDateObj():Date{
        if(this._endDate && this._endDate > 0) return new Date(this._endDate);
        return ;
    }
    set endDate(_dt:number){
        this._endDate = _dt
    }
    get rootCause():string{
        return this._rootCause;
    }
    set rootCause(_rtCause:string){
        if(this.oldRootCause == null){
            this.oldRootCause = this._rootCause;
        }
        this._rootCause = _rtCause;
    }
    isRootCauseChanged():boolean{
        if(this.oldRootCause != null && this.oldRootCause != this._rootCause) return true;
        return false;
    }
    get causes():Array<ProblemCause>{
        return this._causes;
    }
    addCause(_probCause:ProblemCause){
        this._causes.push(_probCause);
    }
    get proposedAction():string{
        return this._proposedAction;
    }
    set proposedAction(_prop:string){
        //console.log(this.oldPropAction)
        if(this.oldPropAction == null){
            this.oldPropAction = this._proposedAction;
           // console.log(this.oldPropAction)
        }
        this._proposedAction = _prop
    }
    isProposedActionChanged():boolean{
        if(this.oldPropAction != null && this.oldPropAction != this._proposedAction) return true;
        return false
    }
    get actions():Array<ProblemAction>{
        return this._actions;
    }
    addProposedAction(_propAction:ProblemAction):number{
        this._actions.push(_propAction);
        return this._actions.length;
    }
    removeProposedAction(_index:number){
        this._actions.splice(_index,1);
    }
    get comments():Array<ProblemComment>{
        return this._comments;
    }
    get status():string{
        return this._status;
    }
    set status(_statVal:string){
        this._status = _statVal;
    }
}

export class ProblemCause{
    private oldCause:string;
    constructor(private _typeOfCategory:string,private _cause:string,private _logDoc:string,private _isEnabled:boolean){

    }
    get typeofCategory():string{
        return this._typeOfCategory;
    }
    get details():string{
        return this._cause;
    }
    set details(_det:string){
        if(this.oldCause == null){
            this.oldCause = this._cause;
        }
        this._cause = _det;
    }
    isDetailsChanged():boolean{
        if(this.oldCause != null && this.oldCause != this._cause) return true;
        return false;
    }
    get isEnabled():boolean{
        if(this._isEnabled == null) return false;
        return this._isEnabled;
    }
    set isEnabled(_setEnable:boolean){
        this._isEnabled = _setEnable;
    }
}
export class ProposedAction{
    private oldAction:string;
    constructor(private _action:string,private _log_doc:string){

    }
    get action():string{
        return this._action;
    }
    set action(_act:string){
        if(this.oldAction == null){
            this.oldAction = this._action;
        }
        this._action = _act;
    }
    get isActionChanged():boolean{
        if(this.oldAction != null && this.oldAction != this._action) return true;
        return false;
    }
    get log_doc():string{
        return this._log_doc;
    }
}
export class ProblemAction{
    constructor(private _propAction:string,private _function:string,private _responsible:string, 
                private _targetTimeStamp:number, private _log_doc:string){
                }
    get propAction():string{
        return this._propAction;
    }
    set propAction(_action:string){
        this._propAction = _action;
    }
    get function():string{
        return this._function;
    }
    set function(_func:string){
        this._function = _func;
    }
    get responsible():string{
        return this._responsible;
    }
    set responsible(_resp:string){
        this._responsible = _resp;
    }
    get targetTimeStamp():number{
        return this._targetTimeStamp;
    }
    get targetTimeObj():Date{
        if(this._targetTimeStamp > 0) return new Date(this._targetTimeStamp);
        return null;
    }
    set targetTimeObj(_targetTime:Date){
        this._targetTimeStamp = _targetTime.getTime();
    }
    get log_doc():string{
        return this._log_doc;
    }
    cloneSelf():ProblemAction{
        return new ProblemAction(this._propAction,this._function,this._responsible,this._targetTimeStamp, this._log_doc);
    }
}
export class ProblemComment{
    constructor(private _comment:string,private _timestamp:number,private _user:string,private _status:string){

    }
    get comment():string{
        return this._comment;
    }
    get commentTimeStamp():number{
        return this._timestamp;
    }
    get user():string{
        return this._user;
    }
    get status():string{
        return this._status;
    }
}